"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserContextConsumer = exports.UserContextProvider = void 0;
const React = require("react");
const context = React.createContext({});
exports.UserContextProvider = context.Provider;
exports.UserContextConsumer = context.Consumer;
